import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import React, { useEffect } from "react";
import "./LexicalEditor.css";

const StateLoader = ({ value }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!value) return;
    try {
      const parsed = JSON.parse(value);
      const state = editor.parseEditorState(parsed);
      editor.setEditorState(state);
    } catch {
      console.warn("Invalid Lexical JSON");
    }
  }, [editor, value]);

  return null;
};

const LexicalReadOnly = ({ value }) => {
  if (!value) return null;

  const readOnlyTheme = {
    heading: { h1: "lex-h1", h2: "lex-h2", h3: "lex-h3" },
    text: {
      bold: "lex-bold",
      italic: "lex-italic",
      underline: "lex-underline",
      strikethrough: "lex-strikethrough",
      subscript: "lex-subscript",
      superscript: "lex-superscript",
      code: "lex-code-inline",
    },
    list: { ul: "lex-ul", ol: "lex-ol", listitem: "lex-listitem" },
    link: "lex-link",
    code: "lex-code-block",
  };

  const config = {
    namespace: "BlogDetailView",
    theme: readOnlyTheme,
    editable: false,
    nodes: [
      HeadingNode,
      QuoteNode,
      ListNode,
      ListItemNode,
      CodeNode,
      CodeHighlightNode,
      LinkNode,
      AutoLinkNode,
    ],
    onError(err) {
      console.error("[LexicalReadOnly]", err);
    },
  };
  return (
    <LexicalComposer initialConfig={config}>
      <RichTextPlugin
        contentEditable={
          <ContentEditable
            className="lex-content focus:outline-none !p-0 !min-h-0"
            readOnly
          />
        }
        placeholder={null}
        ErrorBoundary={LexicalErrorBoundary}
      />
      <StateLoader value={value} />
    </LexicalComposer>
  );
};

export default LexicalReadOnly;
